/**
 * Layout de /store/*. Cada sección conserva su pantalla y su cabecera.
 * /store es el inicio; /store?tab= sigue redirigiendo a la ruta antigua.
 */

import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { PageHeader } from '@/components/shared/PageHeader';
import { fichasQueueRedirect, ownPageRedirect, storeSectionForPath, storeTabRedirectTarget } from '@/constants/store-nav';
import { StoreHomePage } from './home/StoreHomePage';

export function StoreSectionLayout() {
    const { pathname } = useLocation();
    const section = storeSectionForPath(pathname);

    return (
        <>
            {section ? (
                <PageHeader title={section.title} description={section.description} />
            ) : null}
            <Outlet />
        </>
    );
}

/**
 * /store es el inicio. ?tab= sigue redirigiendo a la ruta de la pestaña antigua.
 */
export function StoreIndexRedirect() {
    const [params] = useSearchParams();
    const tab = params.get('tab');
    if (tab === 'fichas') return <Navigate to={fichasQueueRedirect(params)} replace />;
    if (tab === 'propios') return <Navigate to={ownPageRedirect(params)} replace />;
    const target = storeTabRedirectTarget(tab);
    if (target) return <Navigate to={target} replace />;
    return <StoreHomePage />;
}
